export function getScrollLeft() {
    let el = document.getElementsByClassName('arrangement-container')[0];
    return el.scrollLeft;
}
